import { IcomxResourceDescriptor } from 'src/services/api/icomx';
import { createContext, useContext } from 'react';

export interface IcomxChatContextValue {
  isEnabled: boolean;
  isLoading: boolean;
  isLaunching: boolean;
  openResourceConversation: (resource: IcomxResourceDescriptor) => void;
}

export const IcomxChatContext = createContext<IcomxChatContextValue | undefined>(undefined);

export function useIcomxChat() {
  const context = useContext(IcomxChatContext);

  if (!context) {
    throw new Error('useIcomxChat must be used within an IcomxChatProvider');
  }

  return context;
}